import { axiosInstance } from '@/http-common'

/**
 * Get asset notification rules for DevExtreme DataGrid
 * Supports pagination and search filtering
 * @param skip - Number of records to skip (for pagination)
 * @param take - Number of records to take (page size)
 * @param searchValue - Search term for filtering
 */
export async function getAssetNotificationRulesGrid(skip: number = 0, take: number = 20, searchValue: string = ''): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/asset-notification-rules/grid', {
      params: { skip, take, searchValue }
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get available parameters for a specific asset
 * Used when creating/editing notification rules
 * @param assetId - Asset ID
 */
export async function getAssetParameters(assetId: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset-notification-rules/asset/${assetId}/parameters`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get available parameters for assets directly assigned to a specific asset group.
 * Used when creating/editing group notification rules.
 * @param groupId - Asset group ID
 */
export async function getAssetGroupParameters(groupId: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset-notification-rules/group/${groupId}/parameters`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get available parameters for assets currently linked to a specific Wirepas gateway.
 * Used when creating/editing gateway-scoped notification rules.
 * @param gwId - Wirepas gateway ID
 */
export async function getAssetGatewayParameters(gwId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset-notification-rules/gateway/${gwId}/parameters`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get Wirepas gateways belonging to the current company (assigned to one of its
 * locations) — used to populate the gateway picker for gateway-scoped rules.
 */
export async function getAssetNotificationRuleGateways(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/asset-notification-rules/gateways')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get single asset notification rule by ID
 * @param id - Rule ID
 */
export async function getAssetNotificationRule(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset-notification-rule/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
